module.exports = __webpack_public_path__ + "static/media/sensory_iconccbba156.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/sensory_icon.svg
// module id = 1341
// module chunks = 0